import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { tellNativePageChanged } from '../store/ducks/navigation-flow';

export const actions = {
  FORWARD: 'NAV::FORWARD',
  BACKWARD: 'NAV::BACKWARD',
  JUMP_TO: 'NAV::JUMP_TO'
};

export const createReducerAndMiddleware = (pageNavigator) => {
  const reducer = (state = pageNavigator.getCurrentPage(), action = {}) => {
    switch (action.type) {
      case actions.FORWARD:
      case actions.BACKWARD:
      case actions.JUMP_TO:
        return action.page;

      default:
        return state;
    }
  };

  const middleware = ({ getState }) => next => (action) => {
    const oldPage = pageNavigator.getCurrentPage();

    if (action.type === actions.FORWARD) {
      pageNavigator.forward(getState(), next);
      action = Object.assign({}, action, { page: pageNavigator.getCurrentPage() });
    } else if (action.type === actions.BACKWARD) {
      pageNavigator.backward(getState(), next);
      action = Object.assign({}, action, { page: pageNavigator.getCurrentPage() });
    } else if (action.type === actions.JUMP_TO) {
      pageNavigator.jumpTo(action.page);
      action = Object.assign({}, action, { page: pageNavigator.getCurrentPage() });
    }

    const newPage = pageNavigator.getCurrentPage();

    if (oldPage !== newPage) {
      tellNativePageChanged(oldPage, newPage);
    }

    return next(action);
  };

  return { navReducer: { page: reducer }, navMiddleware: middleware };
};

class BaseNavigation extends Component {
  render() {
    return this.props.render(this.props.page);
  }
}

BaseNavigation.propTypes = {
  render: PropTypes.func.isRequired,
  page: PropTypes.string.isRequired
};

const NavigationProvider = connect(
  state => ({ page: state.page })
)(BaseNavigation);

const forward = () => ({ type: actions.FORWARD });
const backward = () => ({ type: actions.BACKWARD });
const jumpTo = page => ({ type: actions.JUMP_TO, page });

class NavigationButton extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    if (this.props.onClick) {
      this.props.onClick();
    }

    if (!this.props.skipNavigation) {
      this.props.navigate();
    }
  }

  render() {
    return React.cloneElement(this.props.children, { onClick: this.handleClick });
  }
}

NavigationButton.propTypes = {
  onClick: PropTypes.func,
  navigate: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  skipNavigation: PropTypes.bool
};

const ForwardNavigationButton = connect(
  null,
  (dispatch) => {
    return {
      navigate: () => dispatch(forward())
    };
  }
)(NavigationButton);

const BackwardNavigationButton = connect(
  null,
  (dispatch) => {
    return {
      navigate: () => dispatch(backward())
    };
  }
)(NavigationButton);

const JumpToNavigationButton = connect(
  null,
  (dispatch, ownProps) => ({
    navigate: () => {
      dispatch(jumpTo(ownProps.page));
    }
  })
)(NavigationButton);

export const Navigation = {
  Provider: NavigationProvider,
  Forward: ForwardNavigationButton,
  Backward: BackwardNavigationButton,
  JumpTo: JumpToNavigationButton,
  forward,
  backward,
  jumpTo
};
